/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { chakra } from 'chakra-v3';
import { textRecipe } from '../theme/recipes/Text.recipe';

/**
 * Text Component with Recipe Variants
 *
 * Uses the text recipe from the theme for consistent typography.
 * Base variant is the most common text pattern (16px, DM Sans, normal, 1.4, 0.08px).
 *
 * @example
 * ```tsx
 * <Text variant="body">Default body text</Text>
 * <Text variant="caption">Small caption text</Text>
 * <Text variant="link">Link text</Text>
 * <Text variant="label">Label text</Text>
 * ```
 */
export const Text = chakra('p', textRecipe);
